/**
 * ShowPassword
 */

export default function showPassword() {

  const targets = Array.from(document.querySelectorAll('[data-js="showPassword"]'));


  // When showPassword exists
  if (targets.length > 0) {

    // Show password on click
    var trigger = function () {
      targets.forEach(target => {
        target.addEventListener('click', function (e) {
          if(e.target.classList.contains('icon')) {
            let icon = e.target
            let input = icon.parentNode.querySelector('input')
            input.type === 'password' ? input.type = 'text' : input.type = 'password';
            icon.classList.toggle('icon-eye-slash')
            icon.classList.toggle('icon-eye')
            
          }
        }, false);
      });
    };
    trigger();

   

  }

}
